import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import type { NavItem } from '../../types/navigation';
type ServicesDropdownProps = {
  item: NavItem;
};
export function ServicesDropdown({
  item
}: ServicesDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const children = item.children ?? [];
  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <div ref={ref} className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} data-id="element-238" data-mp="lovkjzs4sz8c">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-haspopup="true" aria-controls="services-menu" className="group flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-2 text-[13px] font-bold uppercase tracking-[0.08em] text-forest/80 lg:px-4 lg:text-[14px] transition-colors hover:bg-olive-50 hover:text-olive focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage" data-id="element-239" data-mp="qm468achnlec">
        {item.label}
        <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-240" data-mp="bxhgrft5dd9e" />
      </button>

      <AnimatePresence data-id="element-241" data-mp="3ffri8siyi7xg">
        {open && <motion.div id="services-menu" initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 6
      }} transition={{
        duration: 0.15
      }} className="absolute left-1/2 top-full w-64 -translate-x-1/2 pt-2" data-id="element-242" data-mp="3fepxfwc5272j">
            <div className="rounded-2xl bg-white p-2 shadow-[0_16px_40px_-12px_rgba(38,58,41,0.25)] ring-1 ring-forest/10" data-id="element-243" data-mp="miom3t7hfjk4">
              {children.length > 0 ? <ul data-id="element-244" data-mp="waudp1ttnyys">
                  {children.map(child => <li key={child.href} data-id="element-245" data-mp="8jydphf7pxgg">
                      <Link to={child.href} onClick={() => setOpen(false)} className="block rounded-xl px-4 py-2.5 text-[15px] font-medium text-forest/80 transition-colors hover:bg-olive-50 hover:text-olive" data-id="element-246" data-mp="8l00gj5lc8e0">
                        {child.label}
                      </Link>
                    </li>)}
                </ul> : <p className="px-4 py-3 text-sm text-forest/50" data-id="element-247" data-mp="1o29xko3zv7lb">Services coming soon.</p>}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}